import React, { useEffect, useState } from "react";

import DataTable from "react-data-table-component";
import ApiService from "../../../services/ApiService";
import { callAlert } from "../../../services/CommonService";
import QuizService from "../../../services/QuizService";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Loader from "../../../features/Loader";
const InvoiceReceipt = () => {
  const [userDetails, setUserDetails] = useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = [
    {
      name: "Invoice ID",
      selector: (d) => d.invoiceId,
      sortable: true,
      wrap: true,
    },
    {
      name: "UTRN",
      selector: (d) => d.utrn,
      sortable: true,
      wrap: true,
    },
    {
      name: "Amount",
      selector: (d) => "₹" + d.totalAmount,
      sortable: true,
    },

    {
      name: "Date/Time",
      selector: (d) => d.paymentDate,
      sortable: true,
    },
    {
      name: "Status",
      selector: (d) => d.paymentStatus,
      sortable: true,
    },
    {
      name: "Mobile No.",
      selector: (d) => d.mobile,
      sortable: true,
    },

    {
      name: "Action",
      selector: "",
      sortable: false,
      cell: (d) => [
        d.paymentStatus ? (
          <button
            onClick={handleClick.bind(this, d)}
            className="btn btn-success btn-sm  links  "
            icon="edit"
          >
            {" "}
            Download{" "}
          </button>
        ) : (
          ""
        ),
      ],
    },
  ];

  const handleClick = (d) => {
    console.log(`You clicked me! ${d.invoiceId}`);

    var imgData =
      "data:image/jpeg;base64,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";
    var company_logo = {
      w: 120,
      h: 80,
    };

    var comapnyJSON = {
      CompanyName: "EFH Tech Services LLP ",
      CompanyGSTIN: "05AAKFE7114R1Z0",
      CompanyState: "Uttarakhand",
      CompanyPAN: "",
      CompanyAddressLine1: "13/2 New Road, opposite",
      CompanyAddressLine2: "MKP college, Dehradun,",
      CompanyAddressLine3: "Uttarakhand, India",
      PIN: "248001",
      companyEmail: "efhdigitalminds@gmail.com",
      // companyEmail: "efhfromhome.prosper.india@gmail.com",
      companyPhno: "+917895926600",
    };

    var today = new Date();
    var year = today.getFullYear();
    var mes = today.getMonth() + 1;
    var dia = today.getDate();
    var fecha = dia + "-" + mes + "-" + year;

    var invoiceJSON = {
      InvoiceNo: d.invoiceId,
      InvoiceDate: fecha,
      TotalAmnt: "INR " + Math.round(d.totalAmount) + "",
    };

    var customer_BillingInfoJSON = {
      CustomerName:
        userDetails.firstName + userDetails.middleName + userDetails.lastName,
      CustomerAddressLine1: userDetails.stateId ? userDetails.stateId : "NA",
      CustomerAddressLine2: "",
      CustomerPhno: d.mobile ? d.mobile : "NA",
    };

    var fontSizes = {
      HeadTitleFontSize: 18,
      Head2TitleFontSize: 16,
      TitleFontSize: 14,
      SubTitleFontSize: 12,
      NormalFontSize: 10,
      SmallFontSize: 8,
    };
    var lineSpacing = {
      NormalSpacing: 12,
    };

    var doc = new jsPDF("p", "pt");
    var rightStartCol1 = 350;
    var rightStartCol2 = 485;
    var rightStartCol3 = 350;
    var rightStartCol4 = rightStartCol3 + 40;

    var startX = 40;
    var InitialstartY = 50;
    var startY = 0;
    var lineHeights = 14;
    doc.setFontSize(fontSizes.SubTitleFontSize);
    doc.setFont("helvetica");

    doc.addImage(
      imgData,
      "JPEG",
      startX,
      (startY += 50),
      company_logo.w,
      company_logo.h
    );
    var tempY = InitialstartY;
    doc.setFont(undefined, "bold");
    doc.text(
      "Invoice No: ",
      rightStartCol1,
      (tempY += lineSpacing.NormalSpacing)
    );
    doc.setFont(undefined, "normal");
    doc.text(invoiceJSON.InvoiceNo, rightStartCol2, tempY);
    doc.setFont(undefined, "bold");
    doc.text(
      "Invoice Date:",
      rightStartCol1,
      (tempY += lineSpacing.NormalSpacing)
    );
    doc.setFont(undefined, "normal");
    doc.text(invoiceJSON.InvoiceDate, rightStartCol2, tempY);
    doc.setFont(undefined, "bold");
    doc.text("Total: ", rightStartCol1, (tempY += lineSpacing.NormalSpacing));
    doc.setFont(undefined, "normal");
    doc.text(invoiceJSON.TotalAmnt, rightStartCol2, tempY);

    doc.setFont(undefined, "bold");
    doc.text(
      comapnyJSON.CompanyName,
      rightStartCol3,
      (startY += 35 + company_logo.h)
    );
    doc.setFontSize(fontSizes.NormalFontSize);

    doc.text(
      "GSTIN",
      rightStartCol3,
      (startY += lineSpacing.NormalSpacing + 6)
    );
    doc.setFont(undefined, "normal");
    doc.text(comapnyJSON.CompanyGSTIN, rightStartCol4, startY);
    doc.setFont(undefined, "bold");
    doc.text("STATE", rightStartCol3, (startY += lineSpacing.NormalSpacing));
    doc.setFont(undefined, "normal");
    doc.text(comapnyJSON.CompanyState, rightStartCol4, startY);
    doc.setFont(undefined, "bold");
    doc.text("PIN", rightStartCol3, (startY += lineSpacing.NormalSpacing));
    doc.setFont(undefined, "normal");
    doc.text(comapnyJSON.PIN, rightStartCol4, startY);
    doc.setFont(undefined, "bold");
    doc.text("EMAIL", rightStartCol3, (startY += lineSpacing.NormalSpacing));
    doc.setFont(undefined, "normal");
    doc.text(comapnyJSON.companyEmail, rightStartCol4, startY);
    doc.setFont(undefined, "bold");
    doc.text("Phone: ", rightStartCol3, (startY += lineSpacing.NormalSpacing));
    doc.setFont(undefined, "normal");
    doc.text(comapnyJSON.companyPhno, rightStartCol4, startY);

    doc.setFont(undefined, "bold");
    //-------Customer Info Billing---------------------
    doc.text(
      "Student Name : ",
      startX,
      (startY += lineSpacing.NormalSpacing - 70)
    );
    doc.setFont(undefined, "normal");
    doc.text(customer_BillingInfoJSON.CustomerName, 115, startY);
    doc.setFont(undefined, "bold");
    doc.text("State : ", startX, (startY += lineSpacing.NormalSpacing));
    doc.setFont(undefined, "normal");
    doc.text(customer_BillingInfoJSON.CustomerAddressLine1, 115, startY);
    doc.text(
      customer_BillingInfoJSON.CustomerAddressLine2,
      115,
      (startY += lineSpacing.NormalSpacing)
    );
    doc.setFont(undefined, "bold");
    doc.text("Phone: ", startX, (startY += lineSpacing.NormalSpacing));
    doc.setFont(undefined, "normal");
    doc.text(customer_BillingInfoJSON.CustomerPhno, 115, startY);

    doc.setFontSize(10);
    startY += 80;

    let bodyArr = [];
    d.subscriptionDetails.forEach((row) => {
      row.courseModules.forEach((d) => {
        bodyArr.push([row.courseName, d.name, "1", d.price, d.price]);
      });
    });

    let tax = d.cgst + d.sgst;
    bodyArr.push(["", "", "", "Subtotal: ", d.amount + ""]);

    if(d.igst){
      bodyArr.push(["", "", "", "IGST @ 18% : ", d.igst + ""]);
    }else{
      bodyArr.push(["", "", "", "CGST @ 9% : ", d.cgst + ""]);
      bodyArr.push(["", "", "", "SGST @ 9% : ", d.sgst + ""]);
    }
    


    bodyArr.push(["", "", "", "Total in INR : ", d.totalAmount + ""]);

    autoTable(doc, {
      head: [["Course", "Module", "QTY", "Rate", "Subtotal (INR)"]],
      body: bodyArr,
      startY: startY,
      headStyles: {
        //cellWidth: 'wrap',

        valign: "top",
        fontStyle: "bold",
        halign: "left", //'center' or 'right'
        fillColor: [45, 87, 152],
        textColor: [255, 255, 255], //White
      },
      columnStyles: {
        0: { halign: "left" },
        1: { halign: "left" },
        2: { halign: "left" },
        3: { halign: "left" },
        4: { halign: "left" },
      },
    });

    startY = doc.previousAutoTable.finalY + 80;

    doc.text(
      "Thanks a lot !!!",
      startX,
      (startY += lineSpacing.NormalSpacing + 50)
    );
    doc.text(
      "Welcome to EFHFamily !!",
      startX,
      (startY += lineSpacing.NormalSpacing)
    );
/*     doc.addImage(
      imgData,
      "JPEG",
      rightStartCol1,
      startY - 40,
      company_logo.w - 10,
      company_logo.h - 5
    );
 */
    doc.setFontSize(8);

    //-------Invoice Footer---------------------
    var rightcol1 = 340;
    var rightcol2 = 430;

    startY = doc.previousAutoTable.finalY + 30;
    doc.setFontSize(fontSizes.NormalFontSize);

    doc.save(`Invoice${d.invoiceId}.pdf`);
  };

  useEffect(() => {
    if (loading) {
      tableList();
    }

    let userDetailss = localStorage.getItem("userDetails");
    if (userDetailss) {
      setUserDetails(JSON.parse(userDetailss));
    } else {
      return;
    }
  }, []);

  function tableList() {
    ApiService.paymentGetRequest("/invoice/summary", true)
      .then((res) => {
        if (res.data?.resultCode == 1) {
          setData(res.data.data ? res.data.data : []);
          setLoading(false);
        } else {
          callAlert("", res?.message);
          setLoading(false);
        }
      })
      .catch((error) => {
        callAlert("", error?.error?.message);
        setLoading(false);
      });
  }

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <DataTable
          columns={columns}
          data={data}
          progressPending={loading}
          pagination
          //className="table"
          //keys="id"
          //fixedHeader
          //selectableRows
        />
      )}
    </div>
  );
};
export default InvoiceReceipt;
